import React, { useEffect, useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../FireBase'; // Import Firestore
import { Container, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Loading from '../components/Loading';

const Billing = () => {
    const [completedSchemes, setCompletedSchemes] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchCompletedSchemes = async () => {
        try {
            setLoading(true);
            const schemesQuery = query(collection(db, 'schemes'), where('status', '==', 'Completed'));
            const schemesSnapshot = await getDocs(schemesQuery);

            const schemesData = schemesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setCompletedSchemes(schemesData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching completed schemes:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCompletedSchemes();
    }, []);

    if (loading) {
        return (
            <div className="loading-screen">
                <Loading />
            </div>
        );
    }

    return (
        <Container fluid className="mt-5">
            <h1>Billing</h1>
            <Table striped bordered hover responsive>
                <thead>
                    <tr className='scheme-det-font-head'>
                      
                        <th>Name</th>
                        
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {completedSchemes.map((scheme, index) => (
                        <tr key={index} className='scheme-det-font'>
                          
                            <td>{scheme.name}</td>
                         
                            <td>
                                <Link to={`/billingdetails/${scheme.id}`} style={{ textDecoration: 'none', color: 'blue' }}>
                                    View Details
                                </Link>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Container>
    );
};

export default Billing;